import {NgModule} from '@angular/core';
import * as ApiServiceProxies from './service-proxies';

@NgModule({
  providers: [
    ApiServiceProxies.VideoServiceProxy
  ]
})

export class ServiceProxiesModule { }



// WEBPACK FOOTER //
// ./src/shared/service-proxies/service-proxies.module.ts